/*! emp-ads.v1.js - Hema Group ad library
 *  Network /21835225003 - Assembled Media
 *  Deployed to TWO hosts (one per business group) as byte-identical files.
 *  Do not edit a deployed copy. Changes come from Assembled and go to both.
 *  Check what is live with EMPRISE_LIB.version in the console.
 *  Hosting requirements and the release register: 10-library-hosting.md
 */
(function () {
  'use strict';

  // TWO deployed copies, ONE source - one host per business group (Only
  // Sales network, Hema network), byte-identical files. Bump this on every
  // release. It is the only way to tell, in five seconds on a live page,
  // whether a site is running the current build - which is the one real
  // risk of maintaining two copies.
  var LIB_VERSION = '1.0.2';

  var NETWORK     = '/21835225003';
  var REFRESH_S   = 60;    // SOW: 60-second in-view refresh
  var MAX_REFRESH = 10;    // per slot, per page view
  var VIEW_RATIO  = 0.5;   // must still be 50% in view to refresh
  var MAX_POS     = 12;    // 'pos' is a Predefined key: 1..12 only
  var ROADBLOCK_N = 3;     // N+ slots from one line item = de-facto takeover

  // Client-hosted. Updated when a takeover is trafficked - a replaced JSON
  // file, not a code release. 60s in-view refresh is the DEFAULT for every
  // slot; this list only exempts sold takeovers from it. The library fails
  // open if the fetch fails, so a missing file means default refresh
  // everywhere. It must exist before the first 100% SOV buy goes live.
  // The host MUST send Access-Control-Allow-Origin: * - this is a
  // cross-origin fetch from thirteen different domains, and without the
  // header the browser blocks it silently and exclusions never load.
  // See 10-library-hosting.md.
  var NO_REFRESH_URL = 'https://www.onlysales.com.au/js/no-refresh.json';

  var CFG = window.EMPRISE || {};

  // Published before the config guard, so the version is readable even on a
  // page where the page-data object is missing - which is exactly the page
  // you will be debugging.
  window.EMPRISE_LIB = { version: LIB_VERSION, network: NETWORK };

  if (!CFG.site) {
    // Fail closed rather than serve untargeted, but say why. A silent return
    // here is indistinguishable from "the script never loaded".
    if (window.console) {
      console.warn('[emprise] window.EMPRISE.site is missing. No ads defined. ' +
                   'Library v' + LIB_VERSION);
    }
    return;
  }

  // ---- responsive size maps (see architecture doc §4) -------------------
  // 'anchor' is deliberately absent: it is an out-of-page format, never an
  // in-page slot. See the guard in the definition loop.
  // Emprise Group runs NO native ads at this time (decision 8 Sep 2026). The
  // in-feed position is therefore a display row like mrec and footer, not a
  // native card. The Ad Manager in-feed units keep fluid + 348x442 so native
  // can be switched on later with a library release and no inventory change.
  //
  // Row rule (mrec, infeed, footer, every template, every site):
  //   under 768px  300x250 or 320x50
  //   768px and up 728x90 or 300x250
  // Hero (Hema homepages): 320x50/320x100, 728x90 tablet (a 970 does not fit
  // a 768-991px viewport), 970x250/728x90 desktop.
  var ROW = [[[0,0],[[300,250],[320,50]]], [[768,0],[[728,90],[300,250]]]];
  var MAPS = {
    leaderboard: [[[0,0],[[320,100],[320,50]]], [[768,0],[[728,90]]],
                  [[992,0],[[970,250],[728,90]]]],
    hero:        [[[0,0],[[320,50],[320,100]]], [[768,0],[[728,90]]],
                  [[992,0],[[970,250],[728,90]]]],
    infeed:      ROW,
    mrec:        ROW,
    rail:        [[[0,0],[]],          [[768,0],[]],          [[992,0],[[300,600],[300,250]]]],
    footer:      ROW,
    detailmrec:  ROW
  };

  var ROW_DEFAULT = [[728,90],[300,250],[320,50]];
  var DEFAULTS = {
    leaderboard: [[320,100],[320,50],[728,90],[970,250]],
    hero:        [[970,250],[728,90],[320,50],[320,100]],
    infeed:      ROW_DEFAULT,
    mrec:        ROW_DEFAULT,
    rail:        [[300,600],[300,250]],
    footer:      ROW_DEFAULT,
    detailmrec:  ROW_DEFAULT
  };

  // Refresh exclusion is driven by WHAT WAS SOLD, not by where the slot
  // sits: a 100% SOV buy on a homepage or section is excluded. That is a
  // trafficking decision, so it is resolved at render time from the line
  // item that actually filled — see the refresh block below.
  var excl = { li: {}, adv: {}, never: {} };  // populated from NO_REFRESH_URL
  var filledBy    = {};   // in-page divId -> { li, adv }
  var oopIds      = {};   // out-of-page slot ids, excluded from roadblock maths
  var inPageCount = 0;    // in-page slots defined on this page

  var PAGE_KEYS = ['site','pagetype','state','cat','topic','make','model',
                   'vertical','env','listing_id','article_id'];

  window.googletag = window.googletag || { cmd: [] };

  function init() {
    googletag.cmd.push(function () {
      var pubads   = googletag.pubads();
      var toShow   = [];   // display() runs only AFTER enableServices()
      var refreshable = {};

      // ---- page-level config, set ONCE ---------------------------------
      // Current Config API. enableSingleRequest(), setTargeting(),
      // collapseEmptyDivs(), setCentering() and enableLazyLoad() are ALL
      // deprecated PubAdsService methods — do not copy them from the old
      // build or from older tutorials.
      var targeting = {};
      PAGE_KEYS.forEach(function (k) {
        var v = CFG[k];
        if (v === undefined || v === null || v === '') { return; }
        targeting[k] = String(v).toLowerCase();
      });

      googletag.setConfig({
        targeting:     targeting,     // was pubads().setTargeting(k, v)
        singleRequest: true,          // was pubads().enableSingleRequest()
        centering:     true,          // was pubads().setCentering(true)
        collapseDiv:   'ON_NO_FILL',  // was collapseEmptyDivs(true, true)
        lazyLoad: {                   // was pubads().enableLazyLoad({...})
          fetchMarginPercent:  100,   // fetch one viewport ahead
          renderMarginPercent: 50,    // render half a viewport ahead
          mobileScaling:       2.0    // more headroom on mobile scroll
        }
      });

      // ---- define a slot per .emp-ad div --------------------------------
      var nodes = document.querySelectorAll('.emp-ad:not([data-emp-done])');
      Array.prototype.forEach.call(nodes, function (el) {
        var tpl = el.getAttribute('data-emp-tpl');
        var pos = el.getAttribute('data-emp-pos');
        if (!tpl || !pos) { return; }

        // Anchors are out-of-page. A div must never produce an in-page slot
        // on a *-anchor unit — it would request 300x250 against an ad unit
        // that only carries 320x50/320x100 and never fill.
        if (pos === 'anchor') {
          el.setAttribute('data-emp-done', 'skipped-anchor');
          return;
        }

        // 'pos' is Predefined 1..12 in Ad Manager. Skip rather than clamp:
        // clamping 12 and 13 to the same value produces two elements with
        // the same DOM id and one silently ad-less div.
        var raw = el.getAttribute('data-emp-index');
        var idx = (raw === null || raw === '') ? 1 : parseInt(raw, 10);
        if (!(idx >= 1 && idx <= MAX_POS)) {
          el.setAttribute('data-emp-done', 'skipped-bad-index');
          if (window.console) {
            console.warn('[emp-ad] data-emp-index must be 1..' + MAX_POS +
                         ', got "' + raw + '" — slot skipped', el);
          }
          return;
        }

        var mapKey = (tpl === 'detail' && pos === 'mrec') ? 'detailmrec' : pos;
        var sizes = DEFAULTS[mapKey];
        var map   = MAPS[mapKey];
        if (!sizes) { return; }                 // unknown position — do not guess

        var divId = 'gpt-' + CFG.site + '-' + tpl + '-' + pos + '-' + idx;
        var path  = NETWORK + '/' + CFG.site + '/' + tpl + '-' + pos;

        el.id = divId;
        el.setAttribute('data-emp-done', '1');

        var slot = googletag.defineSlot(path, sizes, divId);
        if (!slot) { return; }

        if (map) {
          var b = googletag.sizeMapping();
          map.forEach(function (pair) { b.addSize(pair[0], pair[1]); });
          slot.defineSizeMapping(b.build());
        }

        slot.setConfig({ targeting: { pos: String(idx) } });  // was setTargeting
        slot.addService(pubads);

        // Dev-level override only. Commercial exclusions are handled by
        // ad ops via NO_REFRESH_URL, not by editing the template.
        if (!el.hasAttribute('data-emp-no-refresh')) { refreshable[divId] = true; }
        inPageCount++;
        toShow.push(divId);
      });

      // ---- mobile bottom anchor (out-of-page format) --------------------
      var anchorTpl = document.body.getAttribute('data-emp-anchor');
      if (anchorTpl && window.innerWidth < 768) {
        var aSlot = googletag.defineOutOfPageSlot(
          NETWORK + '/' + CFG.site + '/' + anchorTpl + '-anchor',
          googletag.enums.OutOfPageFormat.BOTTOM_ANCHOR
        );
        if (aSlot) {                       // null where unsupported
          aSlot.setConfig({ targeting: { pos: '1' } });
          aSlot.addService(pubads);
          oopIds[aSlot.getSlotElementId()] = true;   // never counts as a roadblock slot
          toShow.push(aSlot);
        }
      }

      // ---- enableServices BEFORE display -------------------------------
      // Order is load → defineSlot → addService → enableServices → display.
      // Calling display() inside the definition loop fires the ad request
      // early and silently defeats single-request, which breaks roadblocks
      // and therefore the Takeover product.
      googletag.enableServices();
      toShow.forEach(function (s) { googletag.display(s); });

      // ---- refresh exclusion list (fail-open) ---------------------------
      // Fetched once. If it fails, normal refresh continues: a missed
      // takeover exclusion for one flight is recoverable, losing all
      // refresh revenue during a CDN outage is not.
      if (window.fetch) {
        fetch(NO_REFRESH_URL, { cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!j) { return; }
            (j.lineItems   || []).forEach(function (x) { excl.li[String(x)]    = 1; });
            (j.advertisers || []).forEach(function (x) { excl.adv[String(x)]   = 1; });
            // House / RON line items are DESIGNED to fill every unsold slot.
            // Without this they would trip the roadblock backstop on every
            // page and suppress refresh network-wide.
            (j.neverRoadblock || []).forEach(function (x) { excl.never[String(x)] = 1; });
          })
          .catch(function () { /* fail open */ });
      }

      // Record what actually filled each slot, so refresh eligibility can
      // be judged on the campaign rather than the position.
      pubads.addEventListener('slotRenderEnded', function (ev) {
        var id = ev.slot.getSlotElementId();
        if (oopIds[id]) { return; }        // anchor never counts
        if (ev.isEmpty) {
          delete filledBy[id];             // clear stale fill after a refresh
          return;
        }
        filledBy[id] = {
          li:  String(ev.lineItemId  || ''),
          adv: String(ev.advertiserId || '')
        };
      });

      function isRoadblock() {
        // A de-facto takeover: one line item holding BOTH >=3 in-page slots
        // AND a majority of them. Suppresses refresh page-wide even if ad
        // ops forgot to add the line item to the exclusion list.
        //
        // House and RON line items are excluded from this test — they are
        // meant to fill every unsold slot, so counting them would suppress
        // refresh on almost every page view.
        var need = Math.max(ROADBLOCK_N, Math.ceil(inPageCount / 2) + 1);
        var tally = {}, id;
        for (id in filledBy) {
          var li = filledBy[id].li;
          if (!li || excl.never[li]) { continue; }
          tally[li] = (tally[li] || 0) + 1;
          if (tally[li] >= need) { return true; }
        }
        return false;
      }

      function mayRefresh(id) {
        if (!refreshable[id]) { return false; }
        var f = filledBy[id];
        if (!f) { return false; }                       // nothing rendered
        if (excl.li[f.li] || excl.adv[f.adv]) { return false; }  // sold as takeover
        if (isRoadblock()) { return false; }            // de-facto takeover
        return true;
      }

      // ---- viewability-gated refresh ------------------------------------
      // SOW: 60s in-view refresh. NEVER a bare setInterval — that is the
      // Google policy violation in the previous build.
      var counts = {};
      pubads.addEventListener('impressionViewable', function (ev) {
        var slot = ev.slot;
        var id   = slot.getSlotElementId();
        if (!refreshable[id]) { return; }

        counts[id] = counts[id] || 0;
        if (counts[id] >= MAX_REFRESH) { return; }

        setTimeout(function () {
          // Eligibility is evaluated HERE, not at render: it gives the
          // exclusion-list fetch time to land.
          if (!mayRefresh(id)) { return; }
          if (document.visibilityState !== 'visible') { return; }
          var el = document.getElementById(id);
          if (!el) { return; }
          var r  = el.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
          if (visible <= 0 || (visible / r.height) < VIEW_RATIO) { return; }
          counts[id]++;
          pubads.refresh([slot]);
        }, REFRESH_S * 1000);
      });
    });
  }

  // gpt.js is async and googletag.cmd callbacks can run before body parse,
  // so guard on DOM ready — otherwise querySelectorAll matches nothing and
  // document.body is null.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();